import { useEffect, useRef } from "react";
import lottie from "lottie-web";
import animationData from "../assets/demo/data.json";
import "../styles/LottieColorView.css";

const LottieColorView = () => {
  const containerRef = useRef(null);
  const inputRefs = useRef([]);

  // Charger jscolor une seule fois et initialiser les inputs
  useEffect(() => {
    let script;

    const initColorPickers = () => {
      if (window.jscolor) {
        inputRefs.current.forEach((input) => {
          if (input && !input.jscolor) {
            new window.jscolor(input);
          }
        });
      }
    };

    // Charger dynamiquement jscolor
    if (!window.jscolor) {
      script = document.createElement("script");
      script.src = "/js/jscolor.min.js";
      script.async = true;
      script.onload = initColorPickers;
      document.body.appendChild(script);
    } else {
      initColorPickers();
    }

    return () => {
      // Nettoyer les instances jscolor
      inputRefs.current.forEach((input) => {
        if (input && input.jscolor) {
          delete input.jscolor;
        }
      });

      // Supprimer le script si on l’a ajouté nous-mêmes
      if (script) {
        document.body.removeChild(script);
      }
    };
  }, []);

  // Charger l'animation Lottie et mettre à jour les couleurs
  useEffect(() => {
    const anim = lottie.loadAnimation({
      container: containerRef.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData,
    });

    const sheet = document.styleSheets[0];
    const rules = sheet.cssRules || sheet.rules;

    const changeRuleColor = (rule, color) => {
      if (rules[rule]) {
        rules[rule].style.fill = `#${color}`;
        rules[rule].style.stroke = `#${color}`;
      }
    };

    const updateColors = () => {
      inputRefs.current.forEach((input, idx) => {
        if (input) {
          changeRuleColor(idx, input.value);
        }
      });
    };

    const interval = setInterval(updateColors, 100);

    return () => {
      clearInterval(interval);
      anim.destroy();
    };
  }, []);

  return (
    <div>
      <div className="colorControls">
        {["FF597B", "FF8E9E", "F9B5D0", "EEEEEE"].map((defaultColor, idx) => (
          <input
            key={idx}
            defaultValue={defaultColor}
            className="jscolor"
            ref={(el) => (inputRefs.current[idx] = el)}
          />
        ))}
      </div>
      <div id="bodymovin" ref={containerRef}></div>
    </div>
  );
};

export default LottieColorView;
